import React from "react"
import { Row, Col, Tabs, Space } from "antd"
import StatCard from "../components/StatCard"
import QuickActions from "../components/QuickActions"
import NotificationPanel from "../components/NotificationPanel"
import BankTransactions from "../components/BankTransactions"
import {
  ToolOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  InboxOutlined,
  AppstoreOutlined,
  FolderOutlined,
  BarChartOutlined,
  BankOutlined,
  SafetyOutlined,
  TrophyOutlined,
} from "@ant-design/icons"

const InstallerDashboard = ({ infoMessage, telegramLink, userInfo }) => {
  // Mock stats - replace with actual data from props
  const stats = [
    {
      title: "پکیج‌های تخصیص یافته",
      value: 24,
      icon: <ToolOutlined />,
      trend: "up",
      trendValue: "+3 این هفته",
    },
    {
      title: "در حال نصب",
      value: 8,
      icon: <SyncOutlined spin />,
      suffix: "مورد",
    },
    {
      title: "نصب شده",
      value: 156,
      icon: <CheckCircleOutlined />,
      trend: "up",
      trendValue: "این ماه: 12 مورد",
    },
    {
      title: "در انتظار تخصیص",
      value: 5,
      icon: <InboxOutlined />,
    },
  ]

  // Tab items using modern Ant Design API
  const tabItems = [
    {
      key: "1",
      label: (
        <Space>
          <AppstoreOutlined />
          نمای کلی
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            <QuickActions role="Installer" />
          </Col>
          <Col xs={24} lg={16}>
            <NotificationPanel
              telegramLink={telegramLink}
              showTelegram={true}
              maxItems={5}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "3",
      label: (
        <Space>
          <FolderOutlined />
          پکیج‌های من
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <StatCard
              title="لیست پکیج‌های تخصیص یافته"
              value="به زودی"
              icon={<ToolOutlined />}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "4",
      label: (
        <Space>
          <SyncOutlined />
          در حال نصب
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <StatCard
              title="پکیج‌های در حال نصب"
              value="به زودی"
              icon={<SyncOutlined spin />}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "5",
      label: (
        <Space>
          <BarChartOutlined />
          آمار عملکرد
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} lg={6}>
            <StatCard
              title="میانگین زمان نصب"
              value={1.8}
              suffix="روز"
              icon={<ToolOutlined />}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <StatCard
              title="نرخ موفقیت"
              value={96}
              suffix="%"
              icon={<TrophyOutlined />}
              trend="up"
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <StatCard
              title="تعداد ایمنی"
              value={5}
              suffix="گواهینامه"
              icon={<SafetyOutlined />}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <StatCard
              title="امتیاز کیفیت"
              value={4.7}
              suffix="از 5"
              icon={<CheckCircleOutlined />}
              trend="up"
            />
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* Statistics Cards */}
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <StatCard {...stat} />
          </Col>
        ))}
      </Row>

      {/* Main Content */}
      <Tabs
        defaultActiveKey="1"
        size="large"
        type="card"
        items={tabItems}
        destroyInactiveTabPane={true}
      />
    </Space>
  )
}

export default InstallerDashboard
